export const options = [
  { 'es-CL': { label: "Mostrar todas" }, 'en-US':{label:'Show all'}, value: 'all' },
  { 'es-CL': { label: "Audio" }, 'en-US':{label:'Audio'}, value: 'audio' },
  { 'es-CL': { label: "Imagenes" }, 'en-US':{label:'Images'}, value: 'graphic' },
  { 'es-CL': { label: "Video" }, 'en-US':{label:'Video'}, value: 'video' },
  { 'es-CL': { label: "Documentos" }, 'en-US':{label:'Documents'}, value: 'document' },
  { 'es-CL': { label: "Ejecutables" }, 'en-US':{label:'Executables'}, value:'executable' },
  { 'es-CL': { label: "Otras" }, 'en-US':{label:'Others'}, value: 'other' },
];
